import { z } from 'zod';

import { ProviderIdSchema } from './integrations';

export const WorkspaceIntegrationApprovalBodySchema = z.discriminatedUnion(
  'action',
  [
    z.object({
      action: z.literal('request'),
      githubOrg: z.string().min(1),
      provider: ProviderIdSchema.exclude(['github']),
      connectionId: z.string().min(1),
    }),
    z.object({
      action: z.enum(['approve', 'reject']),
      githubOrg: z.string().min(1),
      provider: ProviderIdSchema.exclude(['github']),
      requesterUserId: z.string().min(1),
      connectionId: z.string().min(1),
    }),
  ],
);

export const WorkspaceIntegrationApprovalResponseSchema = z.object({
  ok: z.literal(true),
  status: z.enum(['requested', 'approved', 'rejected']),
});

export type WorkspaceIntegrationApprovalBody = z.infer<
  typeof WorkspaceIntegrationApprovalBodySchema
>;

export interface WorkspaceIntegrationApprovalRequestView {
  readonly requesterUserId: string;
  readonly connectionId: string;
  readonly accountLabel: string;
  readonly requesterLabel: string;
  readonly expiresAt: string;
}
